import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesSoporte() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      {user.menu_soporte ? (
        <div className="container">
          <br />
          <br />
          <Row>
            <Col md={3} align="center">
              {user.menu_soporte ? (
                <Button
                  href="/ListadoProyectosSoporte"
                  className="botonesMenu"
                  color="success"
                >
                  <i className="fas fa-project-diagram fa-7x"></i>
                  <br />
                  <br />
                  Proyectos
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i className="fas fa-project-diagram fa-7x"></i>
                  <br />
                  <br />
                  Proyectos
                </Button>
              )}
            </Col>

            <Col md={3} align="center">
              {user.menu_soporte ? (
                <Button href="/ListadoTickets" className="botonesMenu" color="success">
                  <i className="fas fa-ticket-alt fa-7x"></i>
                  <br />
                  <br />
                  Tickets
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i className="fas fa-ticket-alt fa-7x"></i>
                  <br />
                  <br />
                  Tickets
                </Button>
              )}
            </Col>

            <Col md={3} align="center">
              {user.menu_soporte ? (
                <Button href="/DashboardSoporte" className="botonesMenu" color="success">
                  <i className="fas fa-chart-bar fa-7x"></i>
                  <br />
                  <br />
                  Dashboard
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i className="fas fa-chart-bar fa-7x"></i>
                  <br />
                  <br />
                  Dashboard
                </Button>
              )}
            </Col>

            <Col md={3} align="center">
              {user.menu_soporte_config ? (
                <Button href="/ConfiguracionSoporte" className="botonesMenu" color="success">
                  <i className="fas fa-cog fa-7x"></i>
                  <br />
                  <br />
                  Configuración
                </Button>
              ) : (
                <Button disabled className="botonesMenu" color="success">
                  <i className="fas fa-cog fa-7x"></i>
                  <br />
                  <br />
                  Configuración
                </Button>
              )}
            </Col>
          </Row>
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesSoporte;
